import type { ReactNode } from 'react';
import { fontFamily, tg } from '../../theme/tokens';

/**
 * Subtle hint text floating above BottomNav, in the slot normally occupied
 * by `InlineCTA`. Use when no actionable CTA can be shown yet — e.g.
 * "Add 2 photos to continue" before user has uploaded both photos.
 *
 * Same fixed-position slot as `InlineCTA` so they swap cleanly with each
 * other. `pointerEvents: none` keeps it from intercepting taps that should
 * reach content underneath.
 */
export function BottomHint({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 100,
        left: 16,
        right: 16,
        textAlign: 'center',
        fontSize: 13,
        color: tg.textHint,
        fontFamily,
        zIndex: 49,
        pointerEvents: 'none',
      }}
    >
      {children}
    </div>
  );
}
